import { z } from 'zod'

export const schema = z.array(
  z.object({
    bookmarksListDoc: z.object({
      travelerUid: z.string(),
      listId: z.number().int(),
      listName: z.string(),
      listDescription: z.string().nullable().optional(),
    }),
  }),
)

export type schemaType = z.infer<typeof schema>
